<template
  ><div class="controls">
    <button class="control" @click="$emit('inc')">
      <img class="left" src="@/assets/top-selling/arrow.svg" alt="" />
    </button>
    <p class="display">
      <span class="highlight">{{ displaying }}</span> / {{ max }}
    </p>
    <button class="control" @click="$emit('dec')">
      <img class="right" src="@/assets/top-selling/arrow.svg" alt="" />
    </button>
  </div>
</template>

<script>
export default {
  name: "Controls",
  props: ["displaying", "max"]
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.controls {
  display: flex;
  justify-content: center;
  align-items: center;
}

.display {
  margin: 0 0.5rem;
}
.display {
  font: normal 27px/32px $courier;
  color: $black;
}
.highlight {
  color: $gold;
}

.control {
  height: 100%;
  border: none;
  background: none;
}

.control:hover {
  cursor: pointer;
}

.left {
  transform: rotate(180deg);
}

img {
  height: 2rem;
  display: block;
}
</style>
